import { useRef } from 'react';
import { getMediaUrl } from '../utils/api';

const Image = ({shapesIn, mediaId, width, height, maxHeight, onClick, alignLeft}) => {
  const imageRef = useRef<SVGImageElement | null>(null);

  function handleOnClick(e) {
    if (onClick && imageRef.current) {
      const dim = imageRef.current.getBoundingClientRect();
      const dx = width/dim.width;
      const dy = height/dim.height;
      const x = Math.round((e.clientX - dim.left) * dx);
      const y = Math.round((e.clientY - dim.top) * dy);
      onClick(x, y);
    }
  }

  const fontSize = 0.01953125*height;
  const strokeWidth = 0.0029296875*height;
  const dy = 0.001953125*height;
  const shapes = [];

  if (shapesIn) {
    for (let s of shapesIn) {
        const r = 0.0009765625*height*s.r;
        shapes.push(<circle key={shapes.length} cx={s.x} cy={s.y} r={r} fill="none" stroke="white" strokeWidth={strokeWidth*1.5} />)
        shapes.push(<circle key={shapes.length} cx={s.x} cy={s.y} r={r} fill="none" stroke="black" strokeWidth={strokeWidth} />)
        if (s.text) {
        shapes.push(<text key={shapes.length} x={s.x-r} y={s.y+r+fontSize} fontSize={fontSize} fill="black" filter="url(#solid)">{s.text}</text>);
        }
    };
    
    if (shapes.length >= 1) {
        const sIn = shapesIn[0];
        const r = 0.0009765625*height*sIn.r;
        
        shapes.push(<line key={-1} x1={sIn.x-(r/2)} y1={sIn.y-r+dy} x2={sIn.x-r} y2={sIn.y-(r*1.5)} stroke="white" strokeWidth={strokeWidth*1.5} />);
        shapes.push(<line key={-2} x1={sIn.x+(r/2)} y1={sIn.y-r+dy} x2={sIn.x+r} y2={sIn.y-(r*1.5)} stroke="white" strokeWidth={strokeWidth*1.5} />);
        shapes.push(<line key={-3} x1={sIn.x-(r/2)} y1={sIn.y-r+dy} x2={sIn.x-r} y2={sIn.y-(r*1.5)} stroke="black" strokeWidth={strokeWidth} />);
        shapes.push(<line key={-4} x1={sIn.x+(r/2)} y1={sIn.y-r+dy} x2={sIn.x+r} y2={sIn.y-(r*1.5)} stroke="black" strokeWidth={strokeWidth} />);
    }
    if (shapes.length >= 2 && shapesIn.length >= 2) {
        const sIn = shapesIn[1];
        const r = 0.0009765625*height*sIn.r;
        shapes.push(<line key={-5} x1={sIn.x-(r/2)} y1={sIn.y-r+dy} x2={sIn.x-r} y2={sIn.y-(r*1.5)} stroke="white" strokeWidth={strokeWidth*1.5} />);
        shapes.push(<line key={-6} x1={sIn.x+(r/2)} y1={sIn.y-r+dy} x2={sIn.x+r} y2={sIn.y-(r*1.5)} stroke="white" strokeWidth={strokeWidth*1.5} />);
        shapes.push(<line key={-7} x1={sIn.x-(r/2)} y1={sIn.y-r+dy} x2={sIn.x-r} y2={sIn.y-(r*1.5)} stroke="black" strokeWidth={strokeWidth} />);
        shapes.push(<line key={-8} x1={sIn.x+(r/2)} y1={sIn.y-r+dy} x2={sIn.x+r} y2={sIn.y-(r*1.5)} stroke="black" strokeWidth={strokeWidth} />);
    }
    if (shapesIn.length >= 4) {
        var sIn = shapesIn[shapesIn.length-2];
        var r = 0.0009765625*height*sIn.r;
        shapes.push(<line key={-10} x1={sIn.x-(r/2)} y1={sIn.y+r-dy} x2={sIn.x-r} y2={sIn.y+(r*1.5)} stroke="white" strokeWidth={strokeWidth*1.5} />);
        shapes.push(<line key={-11} x1={sIn.x+(r/2)} y1={sIn.y+r-dy} x2={sIn.x+r} y2={sIn.y+(r*1.5)} stroke="white" strokeWidth={strokeWidth*1.5} />);
        shapes.push(<line key={-12} x1={sIn.x-(r/2)} y1={sIn.y+r-dy} x2={sIn.x-r} y2={sIn.y+(r*1.5)} stroke="black" strokeWidth={strokeWidth} />);
        shapes.push(<line key={-13} x1={sIn.x+(r/2)} y1={sIn.y+r-dy} x2={sIn.x+r} y2={sIn.y+(r*1.5)} stroke="black" strokeWidth={strokeWidth} />);
        
        sIn = shapesIn[shapesIn.length-1];
        r = 0.0009765625*height*sIn.r;
        shapes.push(<line key={-14} x1={sIn.x-(r/2)} y1={sIn.y+r-dy} x2={sIn.x-r} y2={sIn.y+(r*1.5)} stroke="white" strokeWidth={strokeWidth*1.5} />);
        shapes.push(<line key={-15} x1={sIn.x+(r/2)} y1={sIn.y+r-dy} x2={sIn.x+r} y2={sIn.y+(r*1.5)} stroke="white" strokeWidth={strokeWidth*1.5} />);
        shapes.push(<line key={-16} x1={sIn.x-(r/2)} y1={sIn.y+r-dy} x2={sIn.x-r} y2={sIn.y+(r*1.5)} stroke="black" strokeWidth={strokeWidth} />);
        shapes.push(<line key={-17} x1={sIn.x+(r/2)} y1={sIn.y+r-dy} x2={sIn.x+r} y2={sIn.y+(r*1.5)} stroke="black" strokeWidth={strokeWidth} />);
    }
  }

  const viewBox = "0 0 " + width + " " + height;
  return (
    <svg viewBox={viewBox} onClick={handleOnClick} style={{width, height, maxWidth: '100vw', maxHeight}} preserveAspectRatio={alignLeft? "xMinYMin meet" : "xMidYMid meet"}>
      <defs>
        <filter id="solid" x="0" y="0" width="1" height="1">
          <feFlood floodColor="#FFFFFF"/>
          <feComposite in="SourceGraphic"/>
        </filter>
      </defs>
      <image ref={imageRef} href={getMediaUrl(mediaId)} width="100%" height="100%"/>
      {shapes}
    </svg>
  );
}

export default Image;